import CollateralRequirement from '../../models/CollateralRequirement';
function buildCollateralRequirement(collateralRequirement, connector) {
    const { id, token, disputable, actionAmount, challengeAmount, challengeDuration, } = collateralRequirement;
    const collateralRequirementData = {
        id,
        disputableAppId: disputable.id,
        tokenId: token.id,
        tokenSymbol: token.symbol,
        tokenDecimals: token.decimals,
        actionAmount,
        challengeAmount,
        challengeDuration,
    };
    return new CollateralRequirement(collateralRequirementData, connector);
}
export function parseCollateralRequirement(result, connector) {
    const collateralRequirement = result.data.collateralRequirement;
    if (!collateralRequirement) {
        throw new Error('Unable to parse collateral requirement.');
    }
    return buildCollateralRequirement(collateralRequirement, connector);
}
//# sourceMappingURL=collateralRequirements.js.map